import React, { useEffect, useState } from 'react';
import { AlertCircle } from '@saleshandy/icons';

import { IProps } from './types';
import { SequenceAction } from '../../../enums';

import Modal from '../../../../../shared/design-system/ui/modal';
import Checkbox from '../../../../../shared/design-system/components/atoms/checkbox';

import { capitalize } from '../../../../../shared/utils';

const PauseResumeSequenceModal: React.FC<IProps> = ({
  show,
  action,
  onClose,
  onSubmit,
  isRequestPending,
  shouldShowPauseSubsequenceCheckbox = false,
  subsequenceCount = 0,
}) => {
  const [isChecked, setIsChecked] = useState(false);

  const actionMessage = action === SequenceAction.Pause ? 'pause' : 'activate';

  const capitalizedActionMessage = capitalize(actionMessage);

  useEffect(() => {
    if (!show && isChecked) {
      setIsChecked(false);
    }
  }, [show]);

  return (
    <Modal
      show={show}
      className="show-conditions-modal"
      title={
        <div className="d-flex align-items-center gap-10">
          <AlertCircle width={20} height={20} color="#faad14" />
          <span className="line-height-1">{`${capitalizedActionMessage} Sequence`}</span>
        </div>
      }
      onHide={onClose}
      primaryBtnLabel="Yes"
      secondaryBtnLabel="No"
      primaryBtnClickedHandler={() => {
        onSubmit(isChecked);
      }}
      secondaryBtnClickedHandler={onClose}
      primaryBtnDisabled={isRequestPending}
      primaryBtnLoading={isRequestPending}
    >
      <p>{`Are you sure you want to ${actionMessage} the Sequence?`}</p>
      {action === SequenceAction.Pause && shouldShowPauseSubsequenceCheckbox && (
        <p>
          <Checkbox
            checked={isChecked}
            onChange={(checked) => setIsChecked(checked)}
            label={`Pause the ${
              subsequenceCount === 1 ? 'subsequence' : 'subsequences'
            } as well`}
          />
        </p>
      )}
    </Modal>
  );
};

export default PauseResumeSequenceModal;
